import { createContext } from "react";

const SocialContext = createContext();

export default SocialContext;